import React from "react";
import {
    FaCheckCircle,
    FaTimesCircle,
    FaMapMarkerAlt,
    FaBriefcase,
    FaBirthdayCake,
    FaPalette,
    FaBuilding,
} from "react-icons/fa";
import profileImg from "../../assets/default.jpeg";

const UserProfile = () => {
    // Sample data
    const userDetails = {
        name: "Tosin Ekundayo",
        pictures: ["profile-pic1.jpg", "profile-pic2.jpg", "profile-pic3.jpg"],
        location: "Lagos, Nigeria",
        office: "Lagos Office",
        business: "Tech Solutions",
        dob: "1995-07-15",
        complexion: "Dark",
    };

    const companyDetails = {
        name: "Tosin Ekundayo",
        pictures: ["profile-pic1.jpg", "profile-pic2.jpg"],
        location: "London, UK", // Incorrect
        office: "London Office", // Incorrect
        business: "Tech Solutions",
        dob: "1995-07-15",
        complexion: "Dark",
    };

    const renderComparison = (label, userValue, companyValue) => (
        <tr className="border-b">
            <td className="px-4 py-3 flex flex-col items-start text-gray-600 font-medium">
                <div className="flex items-center">
                    {label === "Location" && <FaMapMarkerAlt className="mr-2" />}
                    {label === "Office" && <FaBuilding className="mr-2" />}
                    {label === "Business" && <FaBriefcase className="mr-2" />}
                    {label === "Date of Birth" && <FaBirthdayCake className="mr-2" />}
                    {label === "Complexion" && <FaPalette className="mr-2" />}
                    {label}:
                </div>
                <div className="flex items-center gap-2 mt-2">
                    <span>{userValue}</span>
                    {userValue === companyValue ? (
                        <FaCheckCircle className="text-blue-500" />
                    ) : (
                        <>
                            <FaTimesCircle className="text-red-500" />
                            <span className="ml-2 text-gray-500">{companyValue}</span>
                        </>
                    )}
                </div>
            </td>
        </tr>
    );

    return (
        <div className="container mx-auto p-6 ">
            {/* Profile Pictures at the Top */}
            <div className="flex justify-center gap-6 mb-6">
                {userDetails.pictures.map((picture, index) => (
                    <img
                        key={index}
                        src={profileImg}
                        alt={`Profile ${index + 1}`}
                        className="w-32 h-32 md:w-40 md:h-40 rounded-full border-4 border-gray-200"
                    />
                ))}
            </div>

            <div className="flex justify-center items-center">
                <div className="bg-white w-[90%] max-w-2xl shadow-lg rounded-lg p-6 text-center">
                    {/* User Information */}
                    <h2 className="text-3xl font-bold mb-6 text-gray-800">
                        {userDetails.name}
                    </h2>
                    <table className="table-auto w-full">
                        <tbody className="space-y-4">
                            {renderComparison("Location", userDetails.location, companyDetails.location)}
                            {renderComparison("Office", userDetails.office, companyDetails.office)}
                            {renderComparison("Business", userDetails.business, companyDetails.business)}
                            {renderComparison("Date of Birth", userDetails.dob, companyDetails.dob)}
                            {renderComparison("Complexion", userDetails.complexion, companyDetails.complexion)}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
};

export default UserProfile;
